import {
  Box,
  Button,
  Flex,
  Slider,
  SliderFilledTrack,
  SliderMark,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";
import { Fragment, ReactNode } from "react";
import { BiHourglass } from "react-icons/bi";
import { FormattedMessage } from "react-intl";

import { convertMsToReadableLabel } from "@nens/shared-utils";

interface AnimationControlProps {
  size?: "s" | "l";
  currentTime: number;
  waiting: boolean;
  animating: boolean;
  start: () => void;
  stop: () => void;
  startMs: number;
  endMs: number;
  setCurrentTime: (t: number) => void;
  extraButtons?: ReactNode[];
}

export function AnimationControl({
  currentTime,
  waiting,
  animating,
  start,
  stop,
  startMs,
  endMs,
  size = "s",
  setCurrentTime,
  extraButtons = [],
}: AnimationControlProps) {
  return (
    <Flex flexDirection="row" gap={2} position="absolute" bottom="0" p="8px" w="full">
      {extraButtons.map((button, idx) => (
        <Fragment key={idx}>{button}</Fragment>
      ))}
      {animating ? (
        <Button
          size="md"
          backgroundColor="white"
          variant="outline"
          rounded="md"
          pointerEvents="auto"
          onClick={stop}
        >
          {size === "l" ? (
            <FormattedMessage id="map.pause_animation" defaultMessage="Pause Animation" />
          ) : (
            "⏸"
          )}
        </Button>
      ) : (
        <Button
          size="md"
          backgroundColor="white"
          variant="outline"
          rounded="md"
          pointerEvents="auto"
          onClick={start}
        >
          {size === "l" ? (
            <FormattedMessage id="map.play_animation" defaultMessage="Play Animation" />
          ) : (
            "⏵"
          )}
        </Button>
      )}
      <Box flex="1" m="8px">
        <Slider
          aria-label="animation-slider"
          min={startMs}
          max={endMs}
          value={currentTime}
          w="full"
          onChange={setCurrentTime}
        >
          <SliderTrack>
            <SliderFilledTrack />
          </SliderTrack>
          <SliderThumb />
          <SliderMark
            textAlign="center"
            fontWeight="semibold"
            color="bij12_1.400"
            mt="-10"
            ml="-12"
            w="24"
            value={currentTime}
          >
            {convertMsToReadableLabel(currentTime)}
            {waiting ? <BiHourglass /> : null}
          </SliderMark>
        </Slider>
      </Box>
    </Flex>
  );
}
